export default __webpack_public_path__ + "f05fe2ac8bd6c2c3f7f26c5f287280b9.png";